import { useLanguageCode } from '@procureai/ui-mui';
import { formatDistanceToNow } from 'date-fns';
import { enGB } from 'date-fns/locale';
import { useCallback } from 'react';

import { dateFnsLocaleFromLanguage } from '~/common/i18n';

export const useRelativeTimeFormat = (): ((timestamp: string | Date) => string) => {
  const { languageCode } = useLanguageCode();

  const dateFnsLocale = dateFnsLocaleFromLanguage[languageCode] || enGB;

  const formatFn = useCallback(
    (timestamp: string | Date): string => {
      const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
      return formatDistanceToNow(date, { addSuffix: true, locale: dateFnsLocale });
    },
    [dateFnsLocale],
  );

  return formatFn;
};
